import { DiscountType } from '@app-types/discount';
import { FaiType } from '@app-types/plan';

import { PLAY } from '@constants/provider';

import { EligibilityOffer } from '@eligibility/helpers';

function getAppliedPromo(plan: FaiType, shouldPreferIncitation: boolean): DiscountType | undefined {
    let discount = plan.details.discounts.find((d) => d.isIncitation === shouldPreferIncitation);

    if (!discount) {
        discount = plan.details.discounts.find((d) => d.isIncitation === !shouldPreferIncitation);
    }

    return discount;
}

export function isSameRangeAndPlay<T extends FaiType | EligibilityOffer>(
    offer: T,
    rangeNg: string,
    commercialSeries: string,
    play?: PLAY,
): boolean {
    const rangeNgCommercialSeries = rangeNg + (commercialSeries ? `_${commercialSeries}` : '');
    const currentRangeNgCommercialSeries = `${offer.rangeNg}_${offer.commercialSeries}`;

    return (
        (rangeNgCommercialSeries ? rangeNgCommercialSeries === currentRangeNgCommercialSeries : true) &&
        (play ? play === offer.play : true)
    );
}

export function calculateFaiPrice(plan: FaiType, shouldPreferIncitation: boolean = false): number {
    const discount = getAppliedPromo(plan, shouldPreferIncitation);
    const initialPrice = plan.details.price.initial;
    const priceWithPromo = discount ? initialPrice - discount.discount : initialPrice;

    return Math.round((priceWithPromo + plan.rentalFees) * 100) / 100;
}

export function calculateFaiForeverPrice(plan: FaiType, shouldPreferIncitation: boolean = false): number {
    const discount = getAppliedPromo(plan, shouldPreferIncitation);
    const initialPrice = plan.details.price.initial;
    const priceForever = discount && discount.duration === 0 ? initialPrice - discount.discount : initialPrice;

    return Math.round((priceForever + plan.rentalFees) * 100) / 100;
}
